import { render, staticRenderFns } from "./AdminCity.vue?vue&type=template&id=52fddcfc&"
import script from "./AdminCity.vue?vue&type=script&lang=js&"
export * from "./AdminCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports